<template>
    <div class="advantages">
        <h2 class="section-title">Почему выбирают ПЭК</h2>
        <div class="advantages__info">
            <img src="@/assets/images/fura.png" class="advantages__img" alt="Автомобильные перевозки Беларусь">
            <div class="advantages__list">
                <div class="advantages__list-item">
                    <img class="advantages__list-img" src="@/assets/images/tick-circle.svg" alt="Зеленая галка">
                    <p class="advantages__list-text">Высокая экспертиза в международной логистике</p>
                </div>
                <div class="advantages__list-item">
                    <img class="advantages__list-img" src="@/assets/images/tick-circle.svg" alt="Зеленая галка">
                    <p class="advantages__list-text">Собственные представительства в шести крупнейших городах Беларуси</p>
                </div>
                <div class="advantages__list-item">
                    <img class="advantages__list-img" src="@/assets/images/tick-circle.svg" alt="Зеленая галка">
                    <p class="advantages__list-text">Свыше 300 отделений в России и за рубежом</p>
                </div>
                <div class="advantages__list-item">
                    <img class="advantages__list-img" src="@/assets/images/tick-circle.svg" alt="Зеленая галка">
                    <p class="advantages__list-text">Регулярные рейсы</p>
                </div>
                <div class="advantages__list-item">
                    <img class="advantages__list-img" src="@/assets/images/tick-circle.svg" alt="Зеленая галка">
                    <p class="advantages__list-text">Выгодные тарифы</p>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.advantages {
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}
.advantages__info {
    display: flex;
    gap: 24px;
}
.advantages__img {
    width: 628px;
    height: 504px;
    border-radius: 20px;
}
.advantages__list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
}
.advantages__list-item {
    padding: 24px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    background-color: #F5F5F5;
}
.advantages__list-img {
    border-radius: 8px;
    padding: 6px;
    background-color: #FFFFFF;
}
.advantages__list-text {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.section-title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    margin: 0;
}

@media screen and (max-width: 1279px) {
    .section-title {
        font-size: 24px;
        line-height: 32px;
    }
    .advantages {
        margin-top: 40px;
    }
    .advantages__img {
        display: none;
    }
    .advantages__list {
        width: 100%;
        overflow-x: scroll;
    }
    .advantages__list-item {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }
}

@media screen and (max-width: 768px) {
    .advantages__list {
        flex-direction: row;
    }

    .advantages__list-item {
        gap: 12px;
        padding: 16px;
        min-width: 300px;
        height: 158px;
    }

    .advantages__list-text {
        font-size: 18px;
        line-height: 26px;
    }
}
</style>